import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=2960f98c&scoped=true"
import script from "@/views/Settings/Colors/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Colors/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Colors/create-dialog.scss?vue&type=style&index=0&id=2960f98c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2960f98c",
  null
  
)

export default component.exports